import { useEffect, useState } from "react";
import { _SignList, _single } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import useModal, { MODAL_md, MODAL_SM } from "../../../theme/Component/hooks/useModal";
import { toast } from "react-toastify";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { Modal } from "../../../theme/Component/Modal";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { SignListFormatEditor } from "../../SignListFormat/SignListFormatEditor";



interface Props {
    formType?: number;
    idFormType?: number;
    isModal?: boolean;
    _onChange?: Function;
}

export const SignList = ({ isModal, _onChange, formType, idFormType }: Props) => {

    const { instance, lista, setLista, bean, setBean, isMissing, isRequired, addRequiredFields } = useDataBean(_SignList)

    const modal = useModal("", MODAL_md);
    const modalC = useModal(`Eliminar Firma ${bean.Name}`, MODAL_SM);
    const [selectedFormats, setSelectedFormats] = useState<any[]>([]);

    const head = [
        { title: 'ID', property: "IDSignList", visible: true },
        { title: 'Tipo de Formulario', property: "FormType", visible: false },
        { title: 'ID del Formulario', property: "IDFormType", visible: false },
        { title: 'Tipo de Firma', property: "RenderType", visible: true },
        { title: 'Titulo del cargo', property: "JobTitle", visible: true },
        { title: 'Nombre del Empleado', property: "EmployeeName", visible: true },
    ]

    const setRowBean = (bean: any) => {
        _onChange?.(bean);
        setBean(bean);
    }

    useEffect(() => {
        addRequiredFields(["FormType", "IDFormType", "JobTitle", "EmployeeName"])
        getLista()
    }, [formType, idFormType])

    const renderSign = (type: number) => {
        if (type == 101) {
            return "Firma Interna";
        } else if (type == 102) {
            return "Firma Externa";
        } else {
            return "N/P"
        }
    }

    const getLista = () => {
        let props: any = {
            State: 1
        }

        if (formType) props.FormType = formType;
        if (idFormType) props.IDFormType = idFormType;

        instance.getSignListCatalogPorPropiedades(props, null).then(
            (resp: any) => {
                resp.forEach(element => {
                    const sign = element.DataBeanProperties;

                    sign.RenderType = sign?.SignType ? renderSign(sign.SignType) : "N/P";
                });
                setLista(resp);
            }
        ).catch(err => { toast.error(err) });
    }

    const create = () => {

        let x: any = {
            State: 1,
            IDEmployee: _single.getAccountID(),
        }
        if (formType) x.FormType = formType;
        if (idFormType) x.IDFormType = idFormType;

        setBean(x);
        setSelectedFormats([]);
        modal.open("Agregar Firma de Registro");
    }

    const deleteItem = () => {
        const x = { ...bean, State: 2 };
        editaItem(x);
    };

    const editaItem = async (obj: any, refresh = true) => {
        const requiredFields = ["FormType", "IDFormType", "JobTitle", "EmployeeName", "SignType"];
        const hasMissingFields = requiredFields.some(field => obj[field] === undefined || obj[field] === null || obj[field] === "");

        if (obj.State !== 2 && hasMissingFields) {
            toast.error("Faltan Campos Obligatorios por diligenciar");
            return false;
        }

        try {
            await instance.updateSignList(obj);
            if (refresh) {
                getLista();
                modal.close();
                modalC.close();
            }
            return true;
        } catch (error) {
            toast.error(error as any);
            return false;
        }
    }

    const createItemsFromFormats = async () => {
        if (selectedFormats.length === 0) {
            toast.error("Debe seleccionar al menos una plantilla de firma");
            return;
        }

        const selectedFormType = formType ?? bean.FormType;
        const selectedIDFormType = idFormType ?? bean.IDFormType;

        for (const format of selectedFormats) {
            const sign = {
                IDEmployee: _single.getAccountID(),
                State: 1,
                FormType: selectedFormType,
                IDFormType: selectedIDFormType,
                JobTitle: format.JobTitle ?? "",
                EmployeeName: format.AccountName ?? "",
                SignType: format.SignType,
            };

            const saved = await editaItem(sign, false);
            if (!saved) return;
        }

        toast.success("Firmas agregadas correctamente");
        setSelectedFormats([]);
        getLista();
        modal.close();
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: () => { create() } }
    ]

    const listaBotones = () => {
        const botones = [
            // { titulo: 'Editar', icono: 'ri-edit-2-line', visible: true, evento: () => { modal.open(`Editar Firma de Registro ${bean.EmployeeName}`); } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: true, evento: () => { modalC.open(); } }, ,
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const baseComponent = () => {
        return (
            <>
                {/* <EditorSignList idSelector={value?.IDSignList} onChange={(e) => { setValue(e) }} label="pruebas" /> */}

                <BasicTable listButtons={listaBotones()} iconButtons={iconButtonsItem} head={head} body={lista} rowSet={setRowBean} />

                <ModalConfirm modal={modalC.modal} updateModal={modalC.setModal} eventModal={() => { deleteItem(); }}>
                    Eliminar fima de {bean.JobTitle} - {bean.EmployeeName}
                </ModalConfirm>

                <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={createItemsFromFormats}>
                    <div className="row">
                        {!formType &&
                            <div className="col-md-12">
                                <label className={`${isMissing('FormType') ? 'has-error' : ''}`}>Tipo de Formulario{isRequired('FormType') ? <span className="text-danger">*</span> : ''}</label>
                                <input type="number" className="form-control" value={bean.FormType} onChange={(e) => { setBean({ ...bean, FormType: e.target.value ? Number(e.target.value) : null }) }} />
                            </div>
                        }
                        {!idFormType &&
                            <div className="col-md-12">
                                <label className={`${isMissing('IDFormType') ? 'has-error' : ''}`}>ID del Formulario {isRequired('IDFormType') ? <span className="text-danger">*</span> : ''}</label>
                                <input type="number" className="form-control" value={bean.IDFormType} onChange={(e) => { setBean({ ...bean, IDFormType: e.target.value ? Number(e.target.value) : null }) }} />
                            </div>
                        }
                        <div className="col-md-12">
                            <label className={`${isMissing('JobTitle') ? 'has-error' : ''}`}>Lista de Fimas {isRequired('JobTitle') ? <span className="text-danger">*</span> : ''}</label>
                            <SignListFormatEditor
                                key={modal.modal.view ? "sign-format-open" : "sign-format-closed"}
                                label=" "
                                onChange={(value) => {
                                    setSelectedFormats(value?.ListItems ?? []);
                                }}
                            />
                        </div>
                        {/* 
                        <div className="col-md-12">
                            <label className={`${isMissing('EmployeeName') ? 'has-error' : ''}`}>Nombre Empleado {isRequired('EmployeeName') ? <span className="text-danger">*</span> : ''}</label>
                            <input type="text" className="form-control" value={bean.EmployeeName} onChange={(e) => { setBean({ ...bean, EmployeeName: e.target.value }) }} />
                        </div> */}
                    </div>
                </Modal>
            </>
        )
    }

    return (
        <>
            {isModal ?
                <>
                    {baseComponent()}
                </>
                :
                <BasicPage titulo="Firmas de Registros">
                    {baseComponent()}
                </BasicPage>
            }
        </>
    )
}
